export default "__VITE_ASSET__49e679a9__"